import { catchError, map, Observable, of, shareReplay } from 'rxjs';
import { FeatureFlagResponse } from '../../model/feature-flag.model';

/**
 * Creates a cached feature-flag status resolver.
 *
 * The first request per flag is cached via `shareReplay(1)` and reused for
 * subsequent calls during the lifetime of the service instance.
 */
export function createFeatureFlagStatusResolver(fetchStatus: (flag: string) => Observable<FeatureFlagResponse>) {
  const cache = new Map<string, Observable<boolean>>();

  return (flag: string): Observable<boolean> => {
    const cached = cache.get(flag);
    if (cached) {
      return cached;
    }

    const status$ = fetchStatus(flag).pipe(
      catchError(error => {
        console.error(`Unable to fetch feature flag ${flag}`, error);
        return of({ enabled: false });
      }),
      map(response => response.enabled),
      shareReplay(1),
    );

    cache.set(flag, status$);
    return status$;
  };
}
